import DataGrid, { Column, Scrolling, Selection } from 'devextreme-react/cjs/data-grid';
import notistack from 'modules/core/notistack';
import React, { useState } from 'react'
import { Button, Modal } from 'react-bootstrap';

interface CustomerToFranchiseItemsProp {
    data: any[];
    reloadDataSource(): void;
    closeModal(): void;
    onSave(rows: any[]): void;
}


const ProductDetails: React.FC<CustomerToFranchiseItemsProp> = ({ data, reloadDataSource, closeModal, onSave }) => {

    const [SelectedRows, setSelectedRows] = useState<any[]>();
    const handleSelectionChange = (e: any) => {
        setSelectedRows(e.selectedRowsData.map((item: any) => item));
    };

    const handleSave = () => {
        try {
            if (!SelectedRows || SelectedRows.length === 0) {
                notistack.warning('Select the products to proceed')
                return;
            }
            onSave(SelectedRows);
            reloadDataSource()
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    return (
        <>
            <DataGrid
                dataSource={data}
                remoteOperations={{ groupPaging: true }}
                showRowLines={true}
                keyExpr="id"
                columnAutoWidth={true}
                showBorders={true}
                onSelectionChanged={handleSelectionChange}
            >
                <Scrolling
                    mode='standard'
                    useNative={true}
                    scrollByContent={true}
                    scrollByThumb={true}
                />
                <Selection mode="multiple" />
                <Column dataField="materialType" caption="Material Type" />
                <Column dataField="storeCode" caption="Store Code" />
                <Column dataField="storeName" caption="Store Name" />
                <Column dataField="huid" caption="HUID" />
                <Column dataField="bagNo" caption="Bag No" />
                <Column dataField="styleNumber" caption="Style Number" />
                <Column dataField="category" caption="Category" />
                <Column dataField="karatType" caption="Karat Type" />
                <Column dataField="diaQuantity" caption="Dia Qty" />
                <Column dataField="qty" caption="Qty" />
                <Column dataField="grossWeight" format="#,##0.000" caption="Gross Wt" />
                <Column dataField="netWeight" format="#,##0.000" caption="Net Wt" />
                <Column dataField="diaWt" format="#,##0.000" caption="Dia Wt" />
                <Column dataField="dpPrice" format="#,##0.00" caption="DP Price" />
                <Column dataField="storeAddress" caption="Store Address" />
            </DataGrid>

            <div className='d-flex align-items-center justify-content-end gap-2 p-3'>
                <Button className='add-btn' onClick={closeModal}>
                    Cancel
                </Button>
                <Button className='submit-btn' onClick={handleSave}>
                    Save
                </Button>
            </div>
        </>
    )
}

export default ProductDetails